export function autoToHTML(motd: string | object): string {
    if (typeof motd === "object") {
        return JSONRender(motd);
    } else if (typeof motd === "string") {
        return textToHTML(motd);
    } else {
        return "unknown motd data type";
    }
}

// color code to font styles
const extras: extraLibraryType = {
    "§k": "obfuscated;",
    "§l": "font-weight: bold;",
    "§m": "text-decoration: line-through;",
    "§n": "text-decoration: underline;",
    "§o": "font-style: italic;",
    "§r": "color: inherit;text-decoration: none !important;font-weight:normal!important;font-style: normal!important;",
};

// json extra font styles
const extraFontStyles: extraLibraryType = {
    bold: "font-weight: bold;",
    italic: "font-style: italic;",
    underlined: "text-decoration:underline;",
    strikethrough: "text-decoration: line-through;",
    obfuscated: "mc_obfuscated;",
    reset: "color: inherit;text-decoration: none !important;font-weight:normal!important;font-style: normal!important;",
};

// text to json extra name
const textToJsonExtras: extraLibraryType = {
    "§k": "obfuscated",
    "§l": "bold",
    "§m": "strikethrough",
    "§n": "underlined",
    "§o": "italic",
    "§r": "reset",
};

// base color hex
const colorCodeToHex: extraLibraryType = {
    "§0": "#000000",
    "§1": "#0000AA",
    "§2": "#00AA00",
    "§3": "#00AAAA",
    "§4": "#AA0000",
    "§5": "#AA00AA",
    "§6": "#FFAA00",
    "§7": "#AAAAAA",
    "§8": "#555555",
    "§9": "#5555FF",
    "§a": "#55FF55",
    "§b": "#55FFFF",
    "§c": "#FF5555",
    "§d": "#FF55FF",
    "§e": "#FFFF55",
    "§f": "#FFFFFF",
};

// json extra to hex color
const extraColorsToHex: extraLibraryType = {
    black: "#000000",
    dark_blue: "#0000AA",
    dark_green: "#00AA00",
    dark_aqua: "#00AAAA",
    dark_red: "#AA0000",
    dark_purple: "#AA00AA",
    gold: "#FFAA00",
    gray: "#AAAAAA",
    dark_gray: "#555555",
    blue: "#5555FF",
    green: "#55FF55",
    aqua: "#55FFFF",
    red: "#FF5555",
    light_purple: "#FF55FF",
    yellow: "#FFFF55",
    white: "#FFFFFF",
};

function JSONRender(json: object) {
    return parseJSONToHTML(json as motdJsonType);
}

function parseJSONToHTML(
    sourceJson: motdJsonType,
) {
    let htmlElement = "";
    let colorStyle = "";
    let fontStyle = "";

    // console.log('sourceJson', sourceJson);
    // console.log('---------');

    for (let key of Object.keys(sourceJson)) {
        // console.log('sourceJson key', key);
        key = key.toLowerCase();

        // text styles
        if (Object.prototype.hasOwnProperty.call(extraFontStyles, key)) {
            if (sourceJson[key]) {
                fontStyle += `${extraFontStyles[key]}`;
            }
        }

        // ---------- old text process ----------
        // if (key === "text") {
        //   if (
        //     typeof sourceJson.text === "string" ||
        //     typeof sourceJson.text === "number"
        //   ) {
        //     // convert all type to string
        //     htmlElement += textToHTML(String(sourceJson.text));
        //   }
        // }

        // color
        if (key === "color") {
            const colorKey = sourceJson[key];
            let colorHex = "";

            if (typeof colorKey === "string") {
                // Hex color
                if (Object.prototype.hasOwnProperty.call(extraColorsToHex, colorKey)) {
                    colorHex = extraColorsToHex[colorKey];
                    // color code
                } else if (Object.prototype.hasOwnProperty.call(colorCodeToHex, colorKey)) {
                    colorHex = colorCodeToHex[colorKey];
                    // custom color
                } else {
                    // custom hex color code mode
                    colorHex = colorKey;
                }
            }

            if (colorHex !== "") {
                colorStyle = `color:${colorHex};`;
            }
        }

        // extra
        if (key === "extra" && typeof sourceJson.extra === "object") {
            // ---------- with extra text ----------
            if (sourceJson.text !== undefined
                && (typeof sourceJson.text === "string" || typeof sourceJson.text === "number")
            ) {
                // content to html
                htmlElement += textToHTML(String(sourceJson.text));
            }

            // ---------- foreach extra data and parse ----------
            for (const sourceJsonExtra of sourceJson.extra) {
                // console.log('sourceJsonExtra', sourceJsonExtra);
                if (isMotdJSONType(sourceJsonExtra)) {
                    htmlElement += parseJSONToHTML(sourceJsonExtra);
                }
            }
        }
    }

    // ---------- without extra text content ----------
    if (sourceJson.extra === undefined && sourceJson.text !== undefined) {
        const currentText = sourceJson.text;
        if (
            typeof sourceJson.text === "string" ||
            typeof sourceJson.text === "number"
        ) {
            // convert all type to string
            htmlElement += textToHTML(String(currentText));
        }
    }


    let returnHTML = "";
    if (fontStyle.length !== 0 || colorStyle.length !== 0) {
        returnHTML = `<span style="${colorStyle + fontStyle}">${htmlElement}</span>`;
    } else {
        returnHTML = htmlElement;
    }

    return returnHTML;
}

function textToHTML(motdString: string) {
    const motdText = motdString;

    const colorCodeReg = /([§][0-9a-f0-9a-fA-FklmnorFKLMNORx])/g;
    const codeREGEX = new RegExp(colorCodeReg.source);
    const codeSplit = motdText.split(codeREGEX).filter(item => item !== '');

    let fontStyle = "";
    let colorHex = "";
    let resultHTML = '<span class="motd-line">';

    let fullRgb = "";

    codeSplit.forEach((item) => {
        if (item === "§x") {
            fullRgb = "#";
            return;
        }

        if (fullRgb !== "" && item.match(/§[0-9a-fA-F]/)) {
            fullRgb += item.replace("§", "");
            colorHex = fullRgb;
            return;
        }


        const motdStringToLowerCase = item.toLowerCase();
        // console.log('motdStringToLowerCase', motdStringToLowerCase);

        // 過濾 hex
        if (Object.prototype.hasOwnProperty.call(colorCodeToHex, motdStringToLowerCase)) {
            // console.log(`偵測出 ${ colorCodeToHex[item] }`)
            colorHex = colorCodeToHex[motdStringToLowerCase];

            // §f reset
            // if (motdStringToLowerCase === "§f") {
                fontStyle = "";
            // }
            // 過濾文字 style
        } else if (Object.prototype.hasOwnProperty.call(extras, motdStringToLowerCase)) {
            if (motdStringToLowerCase === "§r") {
                colorHex = "";
                fontStyle = "";
            } else {
                // font style code 轉換
                // console.log(`偵測出 style ${ extras[motdStringToLowerCase] }`);
                fontStyle += extras[motdStringToLowerCase];
            }
            // console.log('motdStringToLowerCase', motdStringToLowerCase);
            // console.log('textFont: ' + fontStyle);
            // 正常文字
        } else {
            let resultColor = "";
            let textContent = item;
            //console.log(fontStyle)

            // 檢查 Hex color
            if (fullRgb !== "") {
                colorHex = fullRgb;
                fullRgb = "";
            }

            if (colorHex !== "") {
                resultColor = `color:${colorHex};`;
            }

            if (textContent !== "") {
                //console.log('font: ' + fontStyle)
                //console.log('color: ' + colorHex)
                //console.log('text: ' + item)
                //console.log('---------------------------------')
                // replace html tags

                textContent = htmlStringFormatting(textContent);

                const contents = textContent.split(/<br\/?>/g);

                if (contents.length > 1) {
                    textContent = contents.map((content) => {
                        return `<span style="${resultColor}${fontStyle}">${content}</span>`;
                    }).join('</span><span class="motd-line">');

                    resultHTML += textContent;
                } else {
                    if (resultColor.length !== 0 || fontStyle.length !== 0) {
                        resultHTML += `<span style="${resultColor}${fontStyle}">${textContent}</span>`;
                    } else {
                        resultHTML += textContent;
                    }
                }
            }
        }
    });

    resultHTML += "</span>";

    return resultHTML;
}

function htmlStringFormatting(text: string): string {
    return (
        text
            // space
            // .replace(/ /g, "\u00a0")
            //
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;")
            // return
            .replace(/\n/g, "<br/>")
    );
    // .replace(/\//g, '&#x2F;');
}

function isMotdJSONType(object: object): object is motdJsonType {
    return !!object;
}

interface motdJsonType {
    text: string | number;
    extra?: {
        color?: string;
        text?: string | number;
        bold?: boolean;
        strikethrough?: boolean;
        underlined?: boolean;
        obfuscated?: boolean;
        italic?: boolean;
        extra?: object[] | motdJsonType[];
    }[];
    translate?: string | number;

    [key: string]: string | boolean | number | object | Array<object> | undefined;
}

interface extraLibraryType {
    [key: string]: string;
}